<div>
  <h1 mat-dialog-title class="title" cdkFocusInitial>{{ 'budget.approveBudgetTitle' | translate }}</h1>
  <div mat-dialog-content>
    <table mat-table [dataSource]="budgetItems" class="table-items mat-elevation-z8">

      <ng-container matColumnDef="codItem">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 5%;"> {{ 'general.codItem' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.codItem}} </td>
      </ng-container>


      <ng-container matColumnDef="partNumber">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 10%;"> {{ 'general.partNumber' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.partNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="item">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 36%;"> {{ 'general.item' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.item}} </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 10%;"> {{ 'general.category' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.category}} </td>
      </ng-container>

      <ng-container matColumnDef="manufacturer">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 10%;"> {{ 'general.manufacturer' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 10%;"> {{ 'general.quantity' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
      </ng-container>

      <ng-container matColumnDef="unitPrice">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 12%;"> {{ 'general.unitPrice' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.unitPrice | number:'1.2-2'}} </td>
      </ng-container>

      <ng-container matColumnDef="totalValue">
        <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 12%;"> {{ 'general.totalValue' | translate }} </th>
        <td mat-cell *matCellDef="let element"> {{element.totalValue | number:'1.2-2'}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsBudget"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsBudget;"></tr>
    </table>

    <div *ngIf="additionalCosts.length > 0">
      <h2 class="subtitle">{{ 'budget.additionalCosts' | translate }}</h2>
      <table mat-table [dataSource]="additionalCosts" class="table-costs mat-elevation-z8">

        <ng-container matColumnDef="costType">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 30%;"> {{ 'general.costType' | translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.costType}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 45%;"> {{ 'general.description' | translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.description || " - "}}  </td>
        </ng-container>

        <ng-container matColumnDef="totalValue">
          <th mat-header-cell *matHeaderCellDef class="table-header" style="width: 25%;"> {{ 'general.totalValue' | translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.totalValue | number:'1.2-2'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAdditional"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsAdditional;"></tr>
      </table>
    </div>

    <div class="total-cost">
      {{ 'general.totalOrder' | translate }}: {{ totalValue | currency:'BRL':'symbol':'1.2-2' }}
    </div>

    @if(generalRemarks){
      <mat-form-field appearance="outline" style="width: 100%">
        <input matInput readonly placeholder="{{ 'general.observations' | translate }}" [value]="generalRemarks">
      </mat-form-field>
    }
  </div>
  <div class="buttons-dialog" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="1%">
    <button class="button-dialog cancel-button" mat-flat-button mat-dialog-close>
      {{ "button.close" | translate }}
    </button>
    <button class="button-dialog confirm-button" mat-dialog-close (click)="confirmDialog()" mat-flat-button>
      {{ "button.confirm" | translate }}
    </button>
  </div>
</div>
